<template>
  <v-card>
    <!-- 💡 POPUP DIALOG: Image ke design ke mutabik -->
    <v-dialog
      v-model="groupCellsDialog"
      max-width="1100px"
    >
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="groupCellsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="selectedQrCode">
            Cells for QRCode: {{ selectedQrCode.QRCode }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text v-exporttocsv="'#groupcells'">
              <v-icon small class="mr-1">save</v-icon> DOWNLOAD
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- Popup Table: Image ke columns ke hisab se -->
        <v-simple-table class="dialog-no-footer" id="groupcells">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Cell #</th>
                <th>Value</th>
                <th>Power</th>
                <th>Average Voltage</th>
                <th>Cell ID</th>
                <th>DAQ SN</th>
                <th>Battery ID</th>
                <th>Customer ID</th>
                <!-- <th class="text-right">Actions</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cell, i) in groupcells" :key="i">
                <td class="font-weight-bold">{{ cell.number }}</td>
                <td>{{ cell.value }}</td>
                <td>{{ cell.power }}</td>
                <td>{{ cell.pov }}</td>
                <td>{{ cell.id }}</td>
                <td>{{ cell.DAQ_SN }}</td>
                <td>
                  <!-- Battery ID bina # ke -->
                  <span v-if="cell.battery_id !== 'N/A'" class="font-weight-bold primary--text">
                    {{ cell.battery_id }}
                  </span>
                  <span v-else class="grey--text">N/A</span>
                </td>
                 <td>
                  <!-- Battery ID bina # ke -->
                  <span v-if="cell.customer_id !== 'N/A'" class="font-weight-bold primary--text">
                    {{ cell.customer_id }}
                  </span>
                  <span v-else class="grey--text">N/A</span>
                </td>
                <!-- <td class="text-right">
                  <v-btn x-small color="grey darken-2" dark @click="openCustomerView(cell)">
                    <v-icon x-small class="mr-1">mdi-account</v-icon> Customer View
                  </v-btn>
                </td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>

    <!-- Main Table -->
    <v-data-table 
      :headers="headers"
      :items="cellList"
      :loading="loading"
      :server-items-length="listCount"
      :options.sync="options"
    >
      <template v-slot:item.QRCode="{ item }">
        <strong class="blue--text">{{ item.QRCode }}</strong>
      </template>

      <template v-slot:item.repeated_count="{ item }">
        <v-chip small color="orange" dark class="font-weight-bold">
          {{ item.repeated_count }} Repeats
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn text small @click="viewItem(item)" class="px-1 mr-2" color="black">
          <v-icon small class="mr-1">remove_red_eye</v-icon> VIEW
        </v-btn>
        <!-- <v-btn text small @click="downloadItem(item)" color="blue" class="px-1">
          <v-icon small class="mr-1">save</v-icon> DOWNLOAD
        </v-btn> -->
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { reusebalancedcells } from "@/api";
import XLSX from 'xlsx';

export default {
  name: "ReuseBalancedCells",
  data: () => ({
    groupCellsDialog: false,
    selectedQrCode: null,
    groupcells: [],
    loading: false,
    options: {},
    cellList: [],
    listCount: 0,
    headers: [
      { text: 'QR Code', value: 'QRCode', align: 'left', sortable: false },
      { text: 'Repeat Count', value: 'repeated_count', sortable: false },
      { text: 'Actions', value: 'action', sortable: false },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    }
  },
  methods: {
    async getList() {
      const { page, itemsPerPage } = this.options;
      this.loading = true;
      try {
        const response = await reusebalancedcells.search(itemsPerPage, page);
        this.listCount = response.data.count;
        this.cellList = response.data.data;
      } catch (error) {
        console.error("Error fetching list", error);
      }
      this.loading = false;
    },

    viewItem(item) {
      this.selectedQrCode = item;
      this.groupcells = item.cells;
      this.groupCellsDialog = true;
    },

    openCustomerView(cell) {
      alert("Opening Customer View for Cell: " + cell.number);
    },

    downloadItem(item) {
      // Aapka existing download logic
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
